import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    {
      title: '位置名称',
      dataIndex: 'local',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.local ? t.local : '-'
      },
    },
    {
      title: '温度',
      dataIndex: 'temperature',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.temperature ? t.temperature + '℃' : '-'
      },
    },
    {
      title: '湿度',
      dataIndex: 'humidity',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.humidity ? t.humidity + '%' : '-'
      },
    },
    {
      title: '措施',
      dataIndex: 'measure',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.measure ? t.measure : '-'
      },
    },
    {
      title: '措施后-温度',
      dataIndex: 'temperatureAfterMeasures',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.temperatureAfterMeasures
          ? t.temperatureAfterMeasures + '℃'
          : '-'
      },
    },
    {
      title: '措施后-湿度',
      dataIndex: 'humidityAfterMeasure',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.humidityAfterMeasure ? t.humidityAfterMeasure + '%' : '-'
      },
    },
    {
      title: '记录员',
      dataIndex: 'recordUserName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.recordUserName ? t?.recordUserName : '-'
      },
    },
    {
      title: '记录时间',
      dataIndex: 'recordDate',
      align: 'center',
      width: '9rem',
      ellipsis: true,
      render: (_, t) => {
        return t.recordDate
          ? moment(t.recordDate).format(DateTimeFormat)
          : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '10rem',
      render: function Element(_, t) {
        return (
          <>
            <Button
              style={{ marginRight: '6px' }}
              type='primary'
              size='small'
              onClick={() => {
                onClick('edit', t)
              }}
            >
              编辑
            </Button>
            <Button
              danger
              style={{ marginRight: '6px' }}
              type='primary'
              ghost
              size='small'
              disabled={t?.isEdit == 1 ? false : true}
              onClick={() => {
                onClick('delete', t)
              }}
            >
              删除
            </Button>
          </>
        )
      },
    },
  ]
}
